






























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Route } from '@/models/route';
import { urlize } from '@/utils';
import FormatHelper from '@/services/format-helper';
import Bro from 'brototype';

@Component
export default class RouteCard extends Vue {

    @Prop(Object) public route: Route;

    get backgroundImage() {
        if (Bro(this.route).doYouEven('images.0.image.medium')) {
            return urlize(this.route.images[0].image.medium);
        }

        return '';
    }

    get routeLength() {
        return FormatHelper.prettyLength_km(this.route.length);
    }

    get uphillDownhill() {
        return FormatHelper.length_m(this.route.uphill + this.route.downhill);
    }

    get duration() {
        return FormatHelper.prettyTime_m(this.route.duration);
    }
}
